module.exports = __webpack_public_path__ + "img/guide.9123262b.svg";